export default __webpack_public_path__ + "static/media/etapa6.29a0e26d.png";